import { faLongArrowLeft } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { styled } from 'linaria/react';
import React from 'react';
import { Link } from 'react-router-dom';
import { config } from '../../shop.config.custom';
import { convertPropsToObject } from '../ContentRender/ContentRender';
import CustomContentHero from './CustomContentHero';
import ContentHero from './ContentHero';

const BackArrowWrapper = styled.div`
  display: inline-block;
  margin-right: 1rem;
  a {
    display: flex;
  }
  svg {
    font-size: 2rem;
  }
`;

export const BackArrow = ({ parents }) => {
  const parentPath = (parents && parents.length > 0 && parents[0].path) || '/';
  return (
    <BackArrowWrapper className="back-arrow">
      <Link to={parentPath}>
        <FontAwesomeIcon icon={faLongArrowLeft} />
      </Link>
    </BackArrowWrapper>
  );
};

const CategoryHeader = ({
  category,
  breadcrumbProps = false,
  standardCategory = true,
  showSubs = true,
}) => {
  const showGrid = config.routes.brand.id.includes(category.id);
  const brandArea = config.routes.brand.id.includes(category.parentId);

  // Check if there is a custom hero through IMAGE-ROW
  const customHeroContent = !showGrid && category?.data?.items?.find(
    (item) =>
      item.properties &&
      item.properties.some(
        (property) => property.name && property.name === 'isHero'
      )
  );

  // If we have custom hero, extract image from it
  const customHeroImage = !showGrid &&
    customHeroContent?.children?.find((c) => c.type === 'image-component') &&
    convertPropsToObject(
      customHeroContent?.children?.find((c) => c.type === 'image-component')
    );

  // If we have custom category image, extract image from it
  const customCategoryImage =
    category?.data?.items?.find((item) => item.type === 'category-image') &&
    convertPropsToObject(
      category?.data?.items?.find((item) => item.type === 'category-image')
    );

  // Check if there is a category image from the category
  const hasImage =
    category?.images && category.images.length && category.images.length > 0;

  // Filter out hero item from content
  const filteredContent = {
    ...category?.data,
    items: category?.data?.items.filter(
      (item) =>
        item.properties &&
        !item.properties.some(
          (property) =>
            property?.name === 'isHero' && property?.value?.value === 'yes'
        )
    ),
  };

  // Sort by priority
  // 1. Custom hero through IMAGE-ROW
  // 2. Custom category image
  // 3. Category images
  // 4. No image
  const image = !!customHeroImage
    ? {
        url: customHeroImage.imageUrl.value,
        alt: customHeroImage.altText?.value,
      }
    : !!customCategoryImage
    ? {
        url: customCategoryImage.categoryImage?.value,
        alt: customCategoryImage.altText?.value,
        imageAspectRatio: customCategoryImage.imageAspectRatio,
      }
    : hasImage
    ? category.images[4]
    : false;

  const categoryProps = {
    brandArea,
    breadcrumbProps,
    category,
    customImage: image,
    hasCustomImage: !!customHeroImage || !!customCategoryImage,
    image,
    showGrid,
    showSubs,
    standardCategory,
    customHeroContent,
    filteredContent,
    customHeroImageUrl: image?.url,
  };

  if (!!customHeroContent) {
    return <CustomContentHero {...categoryProps} />;
  } else {
    return <ContentHero {...categoryProps} />;
  }
};

export default CategoryHeader;
